<div class="row gy-4">
  @if (showTitle()) {
    <div class="col-12">
      <h2 *scText="title()!"></h2>
    </div>
  }
  @if (reviews(); as reviews) {
    <div class="col-12 col-lg-4">
      <wl-review-score
        [button]="button()"
        [stats]="reviews"
        [showCard]="false"
        type="entry"
      />
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      @if (reviews.reviews[0]; as review) {
        <wl-review-single class="d-block h-100" [review]="review" />
      }
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      @if (reviews.reviews[1]; as review) {
        <wl-review-single class="d-block h-100" [review]="review" />
      }
    </div>
  }
</div>
